import { readHiddenListFile, writeHiddenListFile } from './hiddenListFile';

/**
 * Hidden JSON file (in the tool folder) that carries the liked preset ids — its
 * own file rather than a second attribute on the saved-presets one, so the two
 * collections have independent create paths and PATCHes and neither can clobber
 * the other.
 */
export const LIKED_PRESETS_FILE = 'genai-liked-presets.json';

/** Drive file attribute holding the liked ids. See `hiddenListFile`. */
export const LIKED_PRESETS_ATTR = 'genai~likedPresets';

export interface LikedPresets {
  /** CMS documentIds — what the likes service keys on, and rename-proof. */
  documentIds: string[];
  /** Drive file id, or null when the file hasn't been created yet. */
  fileId: string | null;
}

export const getLikedPresets = async ({
  toolId,
}: {
  toolId: string;
}): Promise<LikedPresets | null> => {
  const stored = await readHiddenListFile({
    toolId,
    fileName: LIKED_PRESETS_FILE,
    attribute: LIKED_PRESETS_ATTR,
  });

  return stored ? { documentIds: stored.values, fileId: stored.fileId } : null;
};

export const saveLikedPresets = ({
  toolId,
  documentIds,
  fileId,
}: {
  toolId: string;
  documentIds: string[];
  fileId: string | null;
}): Promise<{ fileId: string | null } | null> =>
  writeHiddenListFile({
    toolId,
    fileName: LIKED_PRESETS_FILE,
    attribute: LIKED_PRESETS_ATTR,
    values: documentIds,
    fileId,
  });
